import { Map } from 'ol';
import { useMapStore } from '@/stores/mapStore';
import { memo } from 'react';
import { RedLineSketchLayer } from './layers/RedlineSketchLayer';
import { UserTrackingLayer } from './layers/UserTrackingLayer';
import { VectorMapLayer } from './layers/VectorLayer';
import { usePermissions } from '@/hooks/usePermissions';
import { CorrectionOverlayLayer } from './layers/CorrectionOverlayLayer';

interface MapLayerManagerProps {
  map: Map | null;
}

export const MapLayerManager = memo(({ map }: MapLayerManagerProps) => {
  const layers = useMapStore((state) => state.layers);
  const permissions = usePermissions();

  if (!map) {
    return null;
  }

  if (layers.length === 0) {
    return null;
  }

  return (
    <>
      {permissions.isAdmin && <UserTrackingLayer map={map} />}
      <RedLineSketchLayer map={map} />
      <CorrectionOverlayLayer map={map} />

      {layers.map((layer) => {
        return <VectorMapLayer key={layer.key} map={map} layerId={layer.id!} />;
      })}
    </>
  );
});
